import sessionStorageService, {
  SESSION_STORAGE_KEYS,
} from './sessionStorageService';

export default {
  get downloadUniqueId(): string {
    return sessionStorageService.getItem(
      SESSION_STORAGE_KEYS.DOWNLOAD_UNIQUE_ID,
    );
  },

  set downloadUniqueId(uniqueId: string) {
    sessionStorageService.setItem(
      SESSION_STORAGE_KEYS.DOWNLOAD_UNIQUE_ID,
      uniqueId,
    );
  },

  removeDownloadUniqueId() {
    sessionStorageService.removeItem(SESSION_STORAGE_KEYS.DOWNLOAD_UNIQUE_ID);
  },

  get secureLinkDownloadUniqueId() {
    return sessionStorageService.getItem(
      SESSION_STORAGE_KEYS.SL_DOWNLOAD_UNIQUE_ID,
    );
  },

  set secureLinkDownloadUniqueId(uniqueId: string) {
    sessionStorageService.setItem(
      SESSION_STORAGE_KEYS.SL_DOWNLOAD_UNIQUE_ID,
      uniqueId,
    );
  },

  removeSecureLinkDownloadUniqueId() {
    sessionStorageService.removeItem(
      SESSION_STORAGE_KEYS.SL_DOWNLOAD_UNIQUE_ID,
    );
  },
};
